import React from "react";
import ReactDOM from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "@/index.css";
import App from "@/App";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const GOOGLE_ONE_TAP_CLIENT_ID = process.env.REACT_APP_GOOGLE_ONE_TAP_CLIENT_ID;

// ============================================================
// Suppress ResizeObserver loop error (benign browser warning)
// This error is harmless and commonly triggered by UI libraries
// Chrome shows this in dev overlay, Safari handles it silently
// ============================================================

// CRITICAL: Run this BEFORE React loads to intercept the error overlay
// This patches the error reporting before react-error-overlay can catch it
if (typeof window !== 'undefined') {
  // Patch ResizeObserver to prevent the error from ever being thrown
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        // Wrap in requestAnimationFrame to prevent "loop completed" error
        window.requestAnimationFrame(() => {
          if (document.hidden) return; // Skip if page is hidden
          callback(entries, observer);
        });
      });
    }
  };

  // Intercept errors at the earliest possible point
  const errorHandler = (event) => {
    if (event.message && event.message.includes('ResizeObserver')) {
      event.stopImmediatePropagation();
      event.preventDefault();
      event.stopPropagation();
      return true;
    }
  };

  // Add handler with capture phase to intercept before React
  window.addEventListener('error', errorHandler, true);
  
  // Also handle it in bubble phase
  window.addEventListener('error', errorHandler, false);

  // Override console.error to filter out ResizeObserver warnings
  const originalConsoleError = console.error;
  console.error = (...args) => {
    if (args[0] && typeof args[0] === 'string' && args[0].includes('ResizeObserver')) {
      return;
    }
    originalConsoleError.apply(console, args);
  };

  // Patch window.onerror
  const originalOnError = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    if (typeof message === 'string' && message.includes('ResizeObserver')) {
      return true;
    }
    return originalOnError ? originalOnError(message, source, lineno, colno, error) : false;
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {GOOGLE_ONE_TAP_CLIENT_ID ? (
      <GoogleOAuthProvider clientId={GOOGLE_ONE_TAP_CLIENT_ID}>
        <App />
      </GoogleOAuthProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>,
);

